<template>
  <div>{{ ActDescBtn }}
    <table style="position: absolute;" width="100%" :height="this.windowSize.height-8"
      :max-height="this.windowSize.height-8">
      <!-- ContenidoBase-Zona-->
      <tr max-height="48px" height="48px">
        <ContenidoBase :titulo="'Configuración de descuento por valor'" :descripcion="'Crear, Modificar y Eliminar Configuración de descuento por valor'"
          :EstadoBtn="EstadoBtn" @abrirBarraTablaDinamica="abrirTabla" @MethodNuevo="newwnuevo" @MethodGuardar="saveConfPv"
          @MethodEliminar="remove" @MethodAnular="anular" @MethodImprimir="imprimirList"
           />
      </tr>
      <!-- fn ContenidoBase-Zona -->
      <tr>
        <!-- BarraPrimaria-Zona  --------------------------------------------------------------------------------->
        <td width="109" :max-height="this.windowSize.height-96" v-show="BarraTablaDinamicaAprir">

          <div class="overflow-y-auto "
            v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px'  }">

            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <center>
                  <!-- <v-btn-toggle></v-btn-toggle> -->
                  <v-btn small width="95%" color="yellow accent-4" @click.prevent="actualiza_tb_ver">
                    <i style="font-size: 25px;" class="fa fa-eye"> </i> ver
                  </v-btn>

                </center>


                <BarraDinamicaNormal
              :nombre="'Configuración de descuento por valor'"
              @EmitDAta="datostabla"
              @EmitBuscar="filtro"
              :SeachNombre="'Búsqueda general'"
              :list="list"

              :headers="[
        { text: 'Código', value: 'codigo' },
        { text: 'Descripcion', value: 'descripcion' } 
        ]"
              :ContListSlot="[
              {Text:'Código', NomValue:'codigo', Ctsl:1, Type:0, State:true},
              {Text:'Descripción', NomValue:'descripcion', Ctsl:1, Type:0, State:true},
              {Text:'Estado',NomValue:'activo', Ctsl:1, Type:0.1, State:true},
              ]"
            />

              </template>
            </v-tooltip>
            
          </div>
        </td>
        <!-- fn BarraPrimaria-Zona  ---------------------------------------------------------------------------------->
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height-96">
          <v-app id="inspire" class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' }">
           <!-- Formulario-Zona  -->
            <div class="px-2">

              <v-card color="grey lighten-3">

                <div class="px-2">

                   <!-- columna 3 -->
                            <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                              <!--------------------------------------------------- tb Factura inicial -->
                              <v-card>
                                <v-toolbar flat color="#BDBDBD" dense>
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                      <v-btn v-on="on" @click.prevent="agregarDatos" color="green" fab x-small dark>
                                        <i style="font-size: 20px" class="fa fa-plus-square"></i>
                                      </v-btn>
                                    </template>
                                    <span>Agregar Descuento automático</span>
                                  </v-tooltip>

                                  <v-toolbar-title class="font-weight-light">
                                    <v-card-title>DESCUENTO AUTOMÁTICO</v-card-title>
                                  </v-toolbar-title>
                                </v-toolbar>

                                <v-form v-model="valid" ref="formDescAut" lazy-validation>
                                  <v-data-table id="TbBord" dense
                                    :headers="[
                                      { text: 'DEPARTAMENTO', value: 'departamento',class: ['no-gutters black--text'] },
                                      { text: 'DESDE', value: 'desde',class: ['no-gutters black--text'] },
                                      { text: 'HASTA', value: 'hasta',class: ['no-gutters black--text'] },
                                      { text: 'DESCUENTO', value: 'descuento',class: ['no-gutters black--text'] },
                                      { text: 'ESPECIAL', value: 'especial' , sortable: false,class: ['no-gutters black--text'] },
                                      { text: 'ACCIÓN', value: 'action', sortable: false,class: ['no-gutters black--text'] },
                                    ]"
                                    :items="ListaMonedaConversion" >
                                    <template v-slot:item.action="{ item }">
                                      <!-- <v-btn fab @click.prevent="editFact(item)" x-small color="grey "><i style="font-size: 20px;" class="fa fa-pencil"></i></v-btn>  -->
                                      <v-btn hide-details class="pa-0 ma-0 py-0 my-0" fab @click.prevent="deleteItem(item)" x-small color="red darken-3">
                                        <i style="font-size: 20px" class="fa fa-trash-o"></i>
                                      </v-btn>
                                    </template>

                                    <template v-slot:item.departamento="props">

                                     <v-combobox autocomplete="off" dense single-line label="" :items="Rdepartamento"
                                        item-text="descripcion" v-model="props.item.departamento" @focus="cargarDepartamento"
                                        @blur="SelctCbDesc(props.item)" class="pt-0 mt-0 fontSize12" style="border:1px solid #CFD8DC;" hide-details>
                                        <template v-slot:prepend>
                                          <i style="font-size: 15px;" class="fa fa-building"></i>
                                        </template>
                                     </v-combobox>

                                    </template>

                                    <template v-slot:item.desde="props">
                                      <AutoNumeric   label=""  dense single-line :rules="[$rules.NumNocero]"
                                        autocomplete="off" v-model.number="props.item.desde"
                                        class="pt-0 mt-0 fontSize12" style="border:1px solid #CFD8DC;" hide-details>
                                        <template v-slot:prepend>
                                          <i style="font-size: 15px" class="fa fa-usd"></i>
                                        </template>
                                      </AutoNumeric>
                                      <!-- <span>{{currencyFormatter(props.item.desde)}}</span> -->
                                    </template>

                                    <template v-slot:item.hasta="props">
                                      <AutoNumeric label="" dense single-line :rules="[$rules.NumNocero]"
                                        autocomplete="off" v-model.number="props.item.hasta"
                                        class="pt-0 mt-0 fontSize12" style="border:1px solid #CFD8DC;" hide-details>
                                        <template v-slot:prepend>
                                          <i style="font-size: 15px" class="fa fa-usd"></i>
                                        </template>
                                      </AutoNumeric>
                                    </template>

                                    <template v-slot:item.descuento="props">
                                      <AutoNumeric label="" :rules="[$rules.required, $rules.porciento2]"
                                         single-line dense v-model="props.item.descuento"
                                         class="pt-0 mt-0 fontSize12" style="border:1px solid #CFD8DC;" hide-details  >
                                        <template v-slot:prepend>
                                          <i style="font-size: 15px" class="fa fa-percent"></i>
                                        </template>
                                      </AutoNumeric>

                                      <!-- <span>{{currencyFormatter(props.item.descuento)}} %</span> -->
                                    </template>

                                    <template v-slot:item.especial="props">

                                      <v-switch style="border:1px solid #CFD8DC;"  class="mt-0 px-2 fontSize12" dense 
                                        v-model="props.item.especial" inset label=""  hide-details  >
                                          <template v-slot:label>
                                            <strong v-if="props.item.especial == true" style="color:#000000; font-size:13px;">Si</strong>
                                            <strong v-if="props.item.especial == false" style="color:#000000; font-size:13px;">No</strong>
                                          </template>
                                      </v-switch>

                                      <!-- <v-switch v-if="props.item.especial == false"
                                        dense v-model="props.item.especial"
                                        inset label="No"></v-switch> -->

                                    </template>
                                  </v-data-table>
                                </v-form>
                              </v-card>
                              <!--------------------------------------------------- fn tb Factura inicial -->
                            </v-col>
                            <!-- fn columna 3 -->


                </div>
              </v-card>
            </div>
            <!-- fn Formulario-Zona  -->
          </v-app>
        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td width="109" :max-height="this.windowSize.height-96" v-show="BarraSecundariaAprir">

          <div class="overflow-y-auto "
            v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px' }">
          </div>

        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->


      </tr>
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ tb-data todo general -->
    <v-dialog label="myAlert" v-model="acti_tb_data" persistent transition="dialog-bottom-transition" fullscreen
      hide-overlay>
      <v-card>
        <v-toolbar dense flat color="#BDBDBD">
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"> </i>
          <v-toolbar-title class="font-weight-light"> REPORTE</v-toolbar-title>
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"> </i>

          <v-spacer></v-spacer>

          <!-- <v-tooltip top>
<template v-slot:activator="{ on }"> 
  <v-btn v-on="on"
                dark
                  small
                  color="deep-purple accent-2"
                  @click.prevent=""
                >
                  <i style="font-size: 25px;" class="fa fa-print"> </i>
                  Listado</v-btn>

 </template>
          <span>Imprimir Listado</span>
        </v-tooltip>  -->

          <v-btn color="grey darken-4" fab small @click="acti_tb_data = !acti_tb_data">
            <i style="font-size: 20px; color:#dd4b39;" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="search" @keyup="filtro" label="Buscar" single-line hide-details>
                <template v-slot:prepend-inner>
                  <i style="font-size: 35px;" class="fa fa-search"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table :headers="[
              { text: 'Código', value: 'codigo', sortable:false, class: ['no-gutters black--text'] },
              { text: 'Descripcion', value: 'descripcion', sortable:false, class: ['no-gutters black--text'] }
            ]" dense :items="list" :search="search" @click:row="datostabla">
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
     <!-- ------------------------------------------------------ fn tb-data todo general -->
   <!-- ------------------------------------------------------ Modal-notificacion general -->
    <v-dialog label="myAlert" v-model="Elim_notif.estado" persistent max-width="350" transition="fab-transition">
      <template justify="center" v-slot:activator="{ on }"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i style="font-size: 28px;" class="fa fa-warning"></i>
            CONFIRMACION
            <i style="font-size: 28px;" class="fa fa-warning"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn @click.prevent="
            eliminar(), (Elim_notif.estado = !Elim_notif.estado)
          " small>
            <i style="font-size: 20px;" class="fa fa-check"></i> Si
          </v-btn>

          <v-btn @click.prevent="Elim_notif.estado = !Elim_notif.estado" small>
            <i style="font-size: 20px;" class="fa fa-ban"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
   <!-- ------------------------------------------------------ Modal-notificacion general -->

    <!------------otras funciones---------------->
    <v-snackbar v-model="aalert.estado" :color="aalert.color" style="margin-top: 20%;" :vertical="true"
      :timeout="120000" top="top">
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- ------------------------------------------------------ Modal- Reporte Basico-->
    <v-dialog transition="fab-transition" label="Modal Reporte Basico" v-model="dialogimprimirList" persistent
      max-width="80%" max-height="50%">
      <ModalReporteBasico @DataReporteBasico="DDataReporteBasico" :Datos="datosImprecion" />
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal Reporte Basico-->


    <!-- fn Modales ----------------------------------------------------------------------------------------------->


  </div>
</template>
<script>
import { EventBus } from "../../event-bus";
import BarraBusqueda2 from "../../components/BarraBusquedaDinam";
import BarraDinamicaNormal from "../../components/BarraDinamicaNormalPlus.vue";
import ContenidoBase from "../../components/ContenidoBase";
import ModalReporteBasico from "../../components/ModalReporteBasico";
import AutoNumeric from "../../components/AutoNumericNuevo";
export default {
  components: {
    BarraBusqueda2,
    BarraDinamicaNormal,
    ContenidoBase,
    ModalReporteBasico,
    AutoNumeric
  },
  created() {
    var json = {
      titulo: "",
      descripcion: "",
      save: true,
      eliminar: false,
      anular: false,
      nuevo: true,
      imprimir: true,
      accion: [
        "CXCTiposClientesNew",
        "CXCTiposClientesSave",
        "CXCTiposClientesRemove",
        "CXCTiposClientesAnular",
        "CXCTiposClientesPrintList"
      ]
    };
    EventBus.$emit("anularBotonesAccion", json);
    this.cargarConfiguraciones();
  },
  mounted() {
    //EventBus.$on("abrirMenuizquierdo", this.abrirTabla);
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    // EventBus.$on("CXCTiposClientesNew", this.new);
    // EventBus.$on("CXCTiposClientesSave", this.save);
    // EventBus.$on("CXCTiposClientesRemove", this.remove);
    // EventBus.$on("CXCTiposClientesAnular", this.remove);
    // EventBus.$on("CXCTiposClientesPrintList", this.imprimirList);
    EventBus.$on("emitCXCTiposClientes", this.datostabla);
    EventBus.$on("onResize", this.onResize);
  },

  data: () => ({
    Rdepartamento:[],
    ListaMonedaConversion:[],
    dialogimprimirList: false,
    datosImprecion: {
      nombre: ' ',
      UrlImprimir: '//Imprimir',
      UrlExel: '//Excel',
      UrlCorreo: '//Correo',
      secuencia: 1,
      documento: 0
    },

    ListaTiposClientes: [],
    windowSize: { width: "auto", height: "auto" },
    configDescuento: {
      activado: true,
      borrado: false,
      codigo: 0,
      descripcion: "",
      fechaCreacion: null,
      fechaModificacion:null,
      usuarioCreacion: "",
      usuarioModifico: "",
    },
    EstadoBtn: {
      BarraTablaDinamicaAprir: false,
      nuevo: false,
      guardar: true,
      eliminar: false,
      anular: false,
      imprimir: false,
      vercuenta: false,
      guardartemporal: false,
      restaurartemporal: false,
      importarDato: false,
      cargarProducto: false,
      ImprimirproductoInv: false,
    },


    files: [],
    text: "",
    valid: true,
    BarraTablaDinamicaAprir: false,
    BarraSecundariaAprir: false,

    headers: [{ text: "Tipos Clientes", value: "descripcion" }],

    slotlist: [
      { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
      {
        dt0: "descripcion",
        dt1: null,
        dt2: null,
        dt3: 1,
        dt4: "Descripcion:"
      },
      { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
    ],

    formData: null,
    list: [],
    search: "",
    acti_tb_data: false,
    Elim_notif: {
      estado: false,
      nombre: "¿Seguro que desea anular este registro?"
    },

    aalert: {
      estado: false,
      color: null
    },

  }),

  //   destroyed() {
  //     location.reload();
  //   },
  methods: {

    onResize(e) {
      //this.windowSize = e
    },

  // Abriendo una panel donde mustra los datos en una tabla.
    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir;

      if (this.BarraTablaDinamicaAprir == true) {

        this.filtro()
        // EventBus.$emit("actualizaBarraDinaicaLim");


      }

    },

    // Un método que se llama cuando el usuario hace clic en una fila de la tabla.
    datostabla(e) {
      this.configDescuento = JSON.parse(JSON.stringify(e));
      this.acti_tb_data = false
    },
   // Envío de una solicitud POST al servidor.
    save() {

    },
    remove() {
      if (this.configDescuento.codigo != 0 && this.configDescuento.codigo != null) {

        this.Elim_notif.estado = !this.Elim_notif.estado;
      } else {
        this.alerta("Seleccione un tipos de cliente para eliminar", "error")
      }


    },
    // Envío de una solicitud de publicación al servidor.
    eliminar() {

    },
    anular() {

    },
  // Un método que se llama cuando el usuario hace clic en un botón y 
  //activa un modal con la opcion de impreciones.
    imprimirList() {
      
    },

    DDataReporteBasico(e) {
      this.dialogimprimirList = e
    },


    // Creando un nuevo objeto y asignándolo a la variable configDescuento.
    newwnuevo() {
      this.ListaMonedaConversion=[]
     /* this.BarraTablaDinamicaAprir = false
      this.configDescuento= {
      activado: true,
      borrado: false,
      codigo: 0,
      descripcion: "",
      fechaCreacion: null,
      fechaModificacion:null,
      usuarioCreacion: "",
      usuarioModifico: "",
    },*/
      EventBus.$emit("actualizaBarraBusqueda2");
      EventBus.$emit("loading", false);
      this.cargarConfiguraciones()
    },

    agregarDatos(e) {
        var json = {
          desde: 0,
          hasta: 0,
          descuento: 0,
          especial: false,
        }
        this.ListaMonedaConversion.push(json)
      },
      deleteItem(item) {
        if (this.ListaMonedaConversion.length != 0) {
          const index = this.ListaMonedaConversion.indexOf(item)
          confirm("estas seguro que desea eliminar este registro de esta tabla?") &&
            this.ListaMonedaConversion.splice(index, 1)
        }
      },

      saveConfPv() {
        var retorna = false
        // if (this.ListaMonedaConversion.length > 0) {
          if (this.$refs.formDescAut.validate()) {
            this.ListaMonedaConversion.forEach((element) => {
              if (element.desde > element.hasta) {
                element.borrado = false
                this.alerta("En descuento automático, 'Desde' es mayor que 'Hasta'", "error")
                retorna = true
                return retorna
              }
            })

            if (retorna == true) {
              return retorna
            } else {

             this.$axios.post(this.$hostname + this.$hName + "/configuraciones/salvarDescuentoRangoValor", this.ListaMonedaConversion, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.ListaMonedaConversion = res.data

            var conf=this.$store.getters.GetConfiguracionGeneral
            conf.configPv.descuetoLista=res.data
            // this.ListaMonedaConversion = res.data.configPv.descuetoLista
             this.UpdateConfguracion(conf),

            this.alerta("se guardo correctamente!", "bien")
          //  this.UpdateConfguracion(res.data), 
            var _this = this
            setTimeout(function () {
             location.reload()
            }, 900)
          })
          .catch((error) => this.alerta(error, "error"))
          
        }


          } else {
            retorna = true
            this.alerta("En el descuento automático hay campo requerido", "error")
            return retorna
          }
        // }

      },

    cargarConfiguraciones() {

   /* var configuraciones = this.$store.getters.GetConfiguracionGeneral
    if (configuraciones.configPv.descuetoLista != null && configuraciones.configPv.descuetoLista.length > 0) {
     this.ListaMonedaConversion = JSON.parse(JSON.stringify(configuraciones.configPv.descuetoLista))
     }*/

          this.$axios.get( this.$hostname + this.$hName + "/configuraciones/findDescuentoRangoValor",
                    { headers: this.$store.getters.GetheadersAxios },
                  )
                  .then((res) => {
                    this.ListaMonedaConversion= res.data
                  })
                  .catch((error) => {this.alerta(error, "error")})

    },

    cargarDepartamento() {
      this.$axios
        .get(
          this.$hostname + this.$hName + "/departamento/activo",
          {
            headers: this.$store.getters.GetheadersAxios
          }
        ).then(res => this.Rdepartamento = res.data)
        .catch(error => {
          if (error.response) {
            this.alerta(error.response.request.responseText, 'error')
          } else {
            this.alerta(error, 'error')
          }
        });
    },

    UpdateConfguracion(e) {
        // this.Reparaloading = false
        EventBus.$emit("loading", false)
        sessionStorage.setItem("ConfiguracionGeneral", JSON.stringify(e))
        this.$store.commit("MutationaddConfiguracionGeneral", e)
      },

      SelctCbDesc(ITEMS) {
  var _this = this
      setTimeout(function() {

       /* if (_this.busquedaCliente == null) {
          _this.busquedaCliente = ""
        }*/
       ITEMS.hasOwnProperty('departamento')  
        if (!ITEMS.hasOwnProperty('departamento') || ITEMS.departamento!=null && !ITEMS.departamento.hasOwnProperty("codigo")) {
           ITEMS.departamento = ""
          ITEMS.departamento = null
          //  _this.alerta("Seleccione un cliente", "error");
          return
        }
      }, 300)

    },

    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);

        this.newwnuevo();
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);

        this.ejecucion = false;
        EventBus.$emit("loading", false);
      }
    },
    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data;
      this.filtro();
    },

  // Hacer una llamada API al backend y obtener los datos de la base de datos.
    async filtro() {


      await this.$axios
        .get(this.$hostname + this.$hName + "/zona/findall", { headers: this.$store.getters.GetheadersAxios })
        .then(res => {
          this.list = res.data;
        });

    }
  },


  computed: {

    ActDescBtn() {


      if (this.configDescuento.codigo > 0) {
        this.EstadoBtn = {
          BarraTablaDinamicaAprir: false,
          nuevo: false,
          guardar: true,
          eliminar: false,
          anular: false,
          imprimir: false,
          vercuenta: false,
          guardartemporal: false,
          restaurartemporal: false,
          importarDato: false,
          cargarProducto: false,
          ImprimirproductoInv: false,
        }
      }


      if (this.configDescuento.codigo <= 0) {


        this.EstadoBtn = {
          BarraTablaDinamicaAprir: false,
          nuevo: false,
          guardar: true,
          eliminar: false,
          anular: false,
          imprimir: false,
          vercuenta: false,
          guardartemporal: false,
          restaurartemporal: false,
          importarDato: false,
          cargarProducto: false,
          ImprimirproductoInv: false,
        }
      }


      this.windowSize=JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))   
    }
  }


};
</script>

<style>

</style>
